import type { TO_DateData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTODateData: Omit<TO_DateData, 'selectedVariable'> = {
  title: 'Default Date Title',
  viewType: 'Date'
};
